import { Component, inject, OnDestroy } from '@angular/core';

import { DynamicFormService } from '@ntap/common';

import {
  ImagePanelItemProviderService,
  ParentItemProviderService
} from '@app/shared';
import { ChooseFromNormativeDbService } from '@app/services';
import { concat, map, tap } from 'rxjs';
import { ItemViewProviderDirective, NtapCommonComponent } from '@ntap/core';
import { ArhivPosjednik } from '@app/shared/models/arhiv-posjednik';

@Component({
  selector: 'app-arhiv-posjednik',
  templateUrl: './arhiv-posjednik.component.html',
  styleUrls: ['./arhiv-posjednik.component.scss'],
  providers: [
    DynamicFormService,
    // { provide: FORM_SERVICE_PROVIDER_TOKEN, useExisting: DynamicFormService }, // OPREZ, ovo ne bi smjeli koristiti na komponentama s child komponentama s formama jer onda SVE niže komponente shareaju isti form service
    ParentItemProviderService,
    ImagePanelItemProviderService
  ]
})
export class ArhivPosjednikComponent
  extends NtapCommonComponent
  implements OnDestroy
{
  itemViewProvider = inject(ItemViewProviderDirective);
  chooseFromNormativeService = inject(ChooseFromNormativeDbService);

  hideDataUntilChosenFromNormative = true;

  doDynamicInit() {
    // FIXME ovaj dio imamo isto na akciji pa razmisliti da refaktoriramo u common providera
    const currentItemHasAgent$ = this.itemViewProvider.item$.pipe(
      map(
        (item: any) =>
          !!(item as ArhivPosjednik)[
            'en~arhiv_posjednik~agent_normativna_baza_id'
          ]
      )
    );
    const agentHasBeenChosen$ = this.chooseFromNormativeService.agentChosen$;
    this.addSubscription(
      concat(currentItemHasAgent$, agentHasBeenChosen$)
        .pipe(
          tap((available) => {
            this.hideDataUntilChosenFromNormative = !available;
          })
        )
        .subscribe()
    );
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.chooseFromNormativeService.clearChoice();
  }
}
